import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {Avatar, Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

import * as intervals from '@explorer/util/intervals';

const defaultSpace = 60;

const StyledAvatar = styled(({locked, selected, ...props}) => (
  <Avatar {...props} />
))(({locked, selected, theme}) => ({
  width: locked ? 20 : 15,
  height: locked ? 20 : 15,
  fontSize: 14,
  color: theme.vars.palette.text.primary,
  position: 'absolute',
  right: '50%',
  transform: `translate(50%, -11px) scale(1)`,
  cursor: 'pointer',
  backgroundColor: theme.vars.palette.grey[100],
  border: selected ? '2px solid' : 'none',
  borderColor: theme.vars.palette.primary.main,
  boxShadow: selected
    ? `0px 0px 0px 6px rgba(${theme.vars.palette.primary.darkChannel} / 0.65)`
    : 'none',
  '&:hover': {
    boxShadow: locked
      ? 'none'
      : selected
        ? `0px 0px 0px 6px rgba(${theme.vars.palette.primary.darkChannel} / 0.65)`
        : `0px 0px 0px 8px color-mix(in srgb, ${theme.vars.palette.grey[100]}, transparent 35%)`,
  },
}));

const Tick = props => (
  <Box
    sx={{
      '&::before, &::after': {
        content: '""',
        display: 'block',
        backgroundColor: 'grey.100',
        position: 'absolute',
        top: 0,
        left: '50%',
      },
      '&::after': {
        top: -2,
        width: '1px',
        height: 8 * 0.75,
      },
    }}
    {...props}
  />
);

const TimelinePeriod = ({period, ...props}) => {
  const isLocked =
    (period.canDownload || period.canStream) && !period.hasResult;

  const width =
    period.interval === intervals.QUARTER
      ? defaultSpace * 1.5
      : period.interval === intervals.DAY
        ? defaultSpace / 2
        : defaultSpace;

  return (
    <Box
      id="timeline-period"
      period-selected={period.selected ? 'true' : undefined}
      data-qe="timeline-period"
      sx={{
        position: 'absolute',
        flexShrink: 0,
        textAlign: 'center',
        width: width,
        top: 'calc(50% - 4px)',
      }}
    >
      {(period.hasResult || period.canDownload || period.canStream) && (
        <StyledAvatar
          locked={isLocked}
          selected={period.selected}
          onClick={props.onClick}
          data-qe="timeline-period-button"
        >
          {isLocked ? <LockOutlinedIcon fontSize="inherit" /> : <span />}
        </StyledAvatar>
      )}
      <Tick>
        <Box
          data-qe="timeline-period-label"
          sx={{
            width: '100%',
            position: 'absolute',
            whiteSpace: 'nowrap',
            top: 6,
          }}
        >
          {props.label}
        </Box>
      </Tick>
    </Box>
  );
};

TimelinePeriod.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  period: PropTypes.object,
  dataQe: PropTypes.string,
};

export default TimelinePeriod;
